import React from "react"

const { Container , Row , Col  , Card , CardBody

} = require("reactstrap")
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { useQuery } from "react-query"
import { getEvents } from "helpers/fakebackend_helper"


const ActivityList = () => {

    const { data, isLoading, refetch } = useQuery('activity_list', getEvents, {
        refetchOnWindowFocus: false,
    });

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags></MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Calender Schedule" breadcrumbItem="Calender Schedule" />

                    <Row>
                        <Col  >
                            <Card>
                                <CardBody>
                                    {isLoading ? (
                                        <div>Loading...</div>
                                    ) : !data?.activity_schedules ? (
                                        <div>No activity schedules available.</div>
                                    ) : (
                                        <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                            <table className="table table-nowrap align-middle mb-0" style={{ minWidth: '800px' }}>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">ID</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Description</th>
                                                        <th scope="col">Start At</th>
                                                        <th scope="col">Category</th>
                                                        <th scope="col">End At</th>
                                                        <th scope="col">Created By</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.activity_schedules.map(schedule => (
                                                        <tr key={schedule.id}>
                                                            <td>{schedule.id}</td>
                                                            <td>{schedule.name}</td>
                                                            <td>{schedule.description}</td>
                                                            <td>{new Date(schedule.start_at).toLocaleString()}</td>
                                                            <td>{schedule.category}</td>
                                                            <td>{new Date(schedule.end_at).toLocaleString()}</td>
                                                            <td>{schedule.created_by?.name}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ActivityList
